module.exports = __webpack_public_path__ + "static/media/easy-churrascaria.8fa30918.png";